import React, { useState } from 'react';
import H1HeaderText from '../../ui/typography/H1HeaderText';
import PrimaryButton from '../../ui/buttons/PrimaryButton';
import BaseText from '../../ui/typography/BaseText';
import InternalLinkButton from '../../ui/buttons/InternalLinkButton';
import { PAGES_ENDPOINTS } from '../../../constants/pages-endpoints';
import { StaticImage } from 'gatsby-plugin-image';
import IconCheckCircle from '../../../images/inline/check-circle.inline.svg';
import { navigate } from 'gatsby';
import { PACKAGE_PRICE_FOR_RENDER } from '../../../constants/enum';
export default function HomePageHeroSection() {
  const [showtag, setShowTag] = useState({
    tag1: true,
    tag2: true,
    tag3: true
  });
  const handleTag = (tag) => {
    setShowTag({ ...showtag, [tag]: false });
  };
  if (!showtag.tag1 && !showtag.tag2 && !showtag.tag3) {
    setTimeout(() => {
      navigate(PAGES_ENDPOINTS.GET_STARTED);
    }, 1000);
  }
  return (
    <div className="global-max-width-wrapper mx-auto flex flex-col md:flex-row gap-4 items-end">
      <div className="py-12 w-full">
        <H1HeaderText
          title={
            <span>
              Hong Kong company <br />
              registration made easy <br />
              From <span className="text-orange-500 text-bold">${PACKAGE_PRICE_FOR_RENDER?.BASIC}</span>
              <span className="text-orange-500 md:text-4xl price text-bold">USD</span>
            </span>
          }
          className="md:whitespace-pre-line"
          textColor="text-white"
        />
        <BaseText textColor="text-white" className="mt-3 mb-5" title="Including:" />
        <BaseText
          textColor="text-white"
          className="mt-4 mb-10 md:whitespace-pre-line"
          title={
            'Remote bank account opening \n 24/7 Access to your Hong Kong company documents \nFree business templates (save up to 3,245USD+)'
          }
        />
        <InternalLinkButton
          fontSize="18px"
          padding="12px 32px"
          fontWeight="text-bold"
          caption="Get Started"
          path={PAGES_ENDPOINTS.GET_STARTED}
        />
        <h2 className="text-23ct text-white text-medium mt-5 mb-4">
          Trusted by <span className="text-bold">1,000+</span> entrepreneurs and SMEs
        </h2>
      </div>
      <div className="relative">
        {' '}
        <div
          onClick={() => handleTag('tag1')}
          className={`absolute z-1 rounded-lg bottom-12 -right-12 floating-point bg-white h-10 items-center gap-2 px-4 iconCapitalCircle cursor-pointer ${
            showtag.tag1 ? 'md:flex hidden' : 'hidden'
          } }`}
        >
          <IconCheckCircle stroke="#004dc1" width="24" height="24" />
          <BaseText fontWeight="text-medium" title="0% Capital Gain Tax" />
        </div>
        <div
          onClick={() => handleTag('tag2')}
          className={`flex absolute z-1 rounded-lg bottom-40 -left-12 floating-point bg-white  h-10 items-center gap-2 px-4 cursor-pointer ${
            showtag.tag2 ? 'md:flex hidden' : 'hidden'
          }`}
        >
          <IconCheckCircle stroke="#004dc1" width="24" height="24" />
          <BaseText fontWeight="text-medium" title="0% tax on offshore profit" />
        </div>
        <div
          onClick={() => handleTag('tag3')}
          className={`flex absolute z-1 rounded-lg top-32 -right-40 floating-point bg-white  h-10 items-center gap-2 px-4 cursor-pointer iconValueCircle
          ${showtag.tag3 ? 'md:flex hidden' : 'hidden'}`}
        >
          <IconCheckCircle stroke="#004dc1" width="24" height="24" />
          <BaseText fontWeight="text-medium" title="0% Value Add Tax (VAT)" />
        </div>
        <StaticImage
          src={'../../../images/homePageImages/hero.png'}
          alt="HeroImage"
          placeholder="blurred"
          layout="fixed"
          loading="eager"
        />
      </div>
    </div>
  );
}
